import { RHFCheckbox, RHFMultiCheckbox, RHFRadioGroup, RHFSelect, RHFSwitch, RHFTextField, RHFUpload, RHFUploadCustomAvatar } from '../hook-form';
import { Autocomplete, MenuItem, Stack, TextField, FormLabel, Typography, Button, Box, Grid, InputAdornment, IconButton, Alert, FormHelperText } from '@mui/material';
import { inputFieldType } from '../../@types/meta';
import { FIELD_TYPES } from '../../commonJson/types';
import { countries } from '../../assets/data';
import { GENDER } from '../../commonJson/common';
import { useFormContext } from 'react-hook-form';
import { fData } from '../../utils/formatNumber';
import { useCallback, useState } from 'react';
import { RHFEditor } from '../hook-form';
import 'react-quill/dist/quill.snow.css';
import Iconify from '../iconify/Iconify';
import { dispatch } from 'src/redux/store';
import { checkOrgName } from 'src/redux/slices/organization';
import { useAuthContext } from 'src/auth/hooks';
import { useSnackbar } from '../snackbar';
import { routePrefix } from 'src/utils/methods/StandardMethods';
import { useLocales } from 'src/locales';
import { RHFTextField2 } from '../hook-form/rhf-text-field';
function RenderSwitch(row: inputFieldType, control: any, handleDrop: any, handleRemoveAllFiles: any, handleRemoveFile: any, handleDropSingle: any, roles: any, showPassword: boolean, setShowPassword: any, setValue: any, values?: any, error?: any, setError?: any, defaultValues?: any, user?: any, enqueueSnackbar?: any, handleSendOtp?: any, handleVerifyEmail?: any, style?: React.CSSProperties) {
    const { translate } = useLocales();
    const options = [
        {
            id: '1',
            label: translate('Yes'),
            value: 'yes'
        },
        {
            id: '2',
            label: translate('No'),
            value: 'no'
        }
    ];
    const checkOrganization = (e: any) => {
        const data = {
            orgName: e.target.value,
            orgCode: e.target.value.split(' ').join('').toLowerCase()
        };
        const orgCode = routePrefix(user);
        (e.target.value !== defaultValues?.orgName) && dispatch(checkOrgName(data, e.target.name, orgCode))
            .then((res) => {

                setError('afterSubmit', null);
                setValue('orgCode', res.orgCode)
            })
            .catch((err) => {
                if (e.target.name === 'orgCode') {
                    setError('afterSubmit', {
                        ...err,
                        message: err.message || err,
                    });
                }
            });
    }
    // console.log('values', values);

    switch (row.type) {
        case FIELD_TYPES.TEXT:
            // console.log('text',row);
            return (<RHFTextField
                key={row.id}
                name={row.name}
                label={`${row.label && translate(row.label)} ${row?.required ? "*" : ""}`}
                // required={row.required}
                variant={row?.readOnly ? 'filled' : 'outlined'}
                InputProps={{ readOnly: row.readOnly }}
                // onBlur={(e) => { row.performAction && checkOrganization(e) }}
                helperText={<span dangerouslySetInnerHTML={{ __html: row?.helperText || '' }}></span>}
                customOnchange={row?.customOnchange}
                style={style}
            // InputLabelProps={{ shrink: values[row?.name] ? true : false }}
            />)
        case FIELD_TYPES.LONGTEXT:
            //console.log('longtext');
            return (<RHFTextField multiline minRows={4} key={row.id} name={row.name} label={row.label && translate(row.label)} required={row.required} variant={row?.readOnly ? 'standard' : 'outlined'} InputProps={{ readOnly: row.readOnly }} />)
        case FIELD_TYPES.NUMBER:
            //console.log('number');
            return (<RHFTextField
                type='number'
                key={row.id}
                name={row.name}
                label={`${row.label && translate(row.label)} ${row?.required ? "*" : ""}`}
                // required={row.required} 
                variant={row.readOnly === true ? 'standard' : 'outlined'}
                InputProps={{ readOnly: row.readOnly }}
                helperText={<span dangerouslySetInnerHTML={{ __html: row?.helperText || '' }}></span>}
                style={style}
            />)
        case FIELD_TYPES.PASSWORD:
            // console.log('text',row);
            // return (<RHFTextField type='password' key={row.id} name={row.name} label={row.label} required={row.required} variant={row?.readOnly ? 'standard' : 'outlined'} InputProps={{ readOnly: row.readOnly }} />)
            return (<RHFTextField
                key={row.id}
                name={row.name}
                // required={row.required}
                label={row.label && translate(row.label)}
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton disabled={row.disableIcon} onClick={() => setShowPassword(!showPassword)} edge="end">
                                <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />)
        case FIELD_TYPES.CHECKBOX:
            return (<><FormLabel>{row.label}</FormLabel>
                {(row?.options || []).map((ele: any, index: number) => (<RHFCheckbox key={`${row.label}${index}`} label={ele.value} name={`${ele.id}`} />))}</>)
        case FIELD_TYPES.EMAIL:
            //console.log('email');
            return (
                <RHFTextField
                    type='email'
                    key={row.id}
                    label={row.label && translate(row.label)}
                    name={row.name}
                    // required={row.required}
                    variant={row.readOnly === true ? 'standard' : 'outlined'}
                    InputProps={{ readOnly: row.readOnly }}
                    helperText={user && user?.isEmailVerified === false && row.verification ?
                        <Alert
                            severity="error"
                            action={(
                                <Button
                                    size='small'
                                    variant='outlined'
                                    sx={{ color: 'black' }}
                                    onClick={() => handleVerifyEmail()}
                                >
                                    {translate("Verify")}
                                </Button>
                            )}
                        >
                            {translate("Your Email not verified yet")}
                        </Alert>
                        : <></>
                    }
                />
            )
        case FIELD_TYPES.RADIO:
            //console.log('radio');
            return (<RHFRadioGroup key={row.id} row name={row.name} label={row.label && translate(row.label)} options={options} />)
        case FIELD_TYPES.BOOLEAN:
            //console.log('boolean');
            return (<RHFSwitch key={row.id} name={row.name} label={row.label && translate(row.label)}></RHFSwitch>)
        case FIELD_TYPES.URL:
            //console.log('url');
            return (<RHFTextField key={row.id} type='url' label={row.label && translate(row.label)} name={row.name} required={row.required} variant={row.readOnly === true ? 'standard' : 'outlined'} InputProps={{ readOnly: row.readOnly }} />)
        case FIELD_TYPES.PHONE:
            // console.log('phone');
            return (
                <Stack direction='row' sx={{ width: '100%' }}>
                    {!row.readOnly && <Grid item xs={3}>
                        <RHFSelect key='code' name="code" label="Code" defaultValue='+91' >
                            <MenuItem key='' value=''>{translate("Please select country code")}</MenuItem>
                            <MenuItem key='+91' value='+91'>+91</MenuItem>
                            <MenuItem key='+971' value='+971'>+971</MenuItem>
                            <MenuItem key='+1' value='+1'>+1</MenuItem>
                        </RHFSelect>
                    </Grid>
                    }
                    <Grid item xs={!row.readOnly ? 9 : 12} sx={{ ml: 0.5, width: '100%' }}>
                        <RHFTextField2
                            type='digit'
                            fullWidth
                            key={row.id} name={row.name}
                            label={row.label && translate(row.label)}
                            required={row.required} variant={row?.readOnly ? 'standard' : 'outlined'}
                            InputProps={{ readOnly: row.readOnly }}
                            helperText={
                                user && user?.isPhoneVerified === false && row.verification ?
                                    <Alert
                                        severity="error"
                                        action={<Button size='small' variant='outlined' sx={{ color: 'black' }} onClick={() => handleSendOtp()}>{translate("Verify")}</Button>}
                                    >
                                        {translate("Your Phone number not verified")}
                                    </Alert>
                                    : <></>

                            }
                            style={style}
                        />
                    </Grid>
                </Stack>
            )
        case FIELD_TYPES.SINGLE_IMAGE:
            return <Stack spacing={1}>
                <Typography key={row.name} variant="subtitle2" sx={{ color: 'text.secondary' }}>{row.label}</Typography>
                <RHFUploadCustomAvatar key={row.id} name="images" maxSize={8145728} onDrop={handleDropSingle}
                    helperText={
                        <Typography key={row.label} variant="caption" sx={{ mt: 2, mx: 'auto', display: 'block', textAlign: 'center', color: 'text.secondary', }}>
                            {translate("Allowed *.jpeg, *.jpg, *.png, *.gif")}<br /> {translate("max size of")} {fData(8145728)}
                        </Typography>
                    }
                />
            </Stack>
        case FIELD_TYPES.IMAGE:
            return <>
                <label>{row?.label && translate(row?.label)}</label>
                <RHFUpload multiple thumbnail name={row.name} maxSize={8145728} onDrop={handleDrop} maxFiles={1}
                    onRemove={handleRemoveFile} onRemoveAll={handleRemoveAllFiles} onUpload={() => console.log('ON UPLOAD')}
                /></>

        case FIELD_TYPES.GENDER_PICKLIST:
            // console.log('genderPicklist');
            return (<RHFSelect key={row.id} name={row.name} label={row.label && translate(row.label)} placeholder={`${row.label}...`} >
                <MenuItem value="">{translate('Please Select Gender')}</MenuItem>
                {GENDER.map((gender, index) => (
                    <MenuItem key={index} value={gender.name}>
                        {translate(gender.label)}
                    </MenuItem>
                ))}
            </RHFSelect>)
        case FIELD_TYPES.COUNTRY_PICKLIST:
            // console.log('genderPicklist');
            return (<RHFSelect key={row.id} name={row.name} label={row.label && translate(row.label)} placeholder={`${row.label}...`} >
                <MenuItem value="">{translate('Please Select a country')}</MenuItem>
                {countries.map((country) => (
                    <MenuItem key={country.code} value={country.label}>
                        {country.label}
                    </MenuItem>
                ))}
            </RHFSelect>)
        case FIELD_TYPES.ROLE_PICKLIST:
            return (<RHFSelect 
            key={row.id} 
            name={row.name}  
            label={row.label && translate(row.label)}
             placeholder={`${row.label}...`} 
             InputProps={{ readOnly: row.readOnly }} 
             >
                <MenuItem value="">{translate('Please Select a role')}</MenuItem>
                {roles?.map((role: any) => (
                    <MenuItem key={role.id} value={role.id}>
                        {translate(role.name)}
                    </MenuItem>
                ))}
            </RHFSelect>)
        case FIELD_TYPES.MULTICHECKBOX:
            return (<RHFMultiCheckbox options={row?.selectOptions || []} name={`${row?.name}`} label={row.label && translate(row.label)} />);

        case FIELD_TYPES.SELECT:
            //console.log('Select');
            return (!row.readOnly ? <><RHFSelect key={row.id} name={row.name} label={row.label && translate(row.label)} placeholder={`${row.label}...`} >
                <MenuItem>{`Please Select ${row.label}`}</MenuItem>
                {(row?.options || []).map((field: any, index: any) => (
                    <MenuItem key={index} value={field?.value}>{field?.label}</MenuItem>
                ))}
            </RHFSelect></> : <RHFTextField key={row.id} name={row.name} label={row.label && translate(row.label)} required={row.required} variant={'standard'} InputProps={{ readOnly: row.readOnly }} />)

        case FIELD_TYPES.DOCUMENT_EDITOR:
            //console.log('Select');
            return (<Stack spacing={1}>
                <Box display="flex" justifyContent="flex-end">
                    <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                        {row.label}
                    </Typography>
                    {/* <Button variant="outlined" sx={{ ml: "auto" }} onClick={() => getChatGPTDescription("Nahargarh tracking tour")}>Fetch Description from ChatGPT</Button> */}
                </Box>
                <RHFEditor name={row.name} />
            </Stack>)
        default:
            return (<RHFTextField key={row.id} name={row.name} label={row.label && translate(row.label)} required={row.required} variant={row?.readOnly ? 'standard' : 'outlined'} InputProps={{ readOnly: row.readOnly }} />)
    }
}

type Props = {
    row: inputFieldType;
    objectId?: any;
    type?: any;
    setType?: any;
    setValue?: any;
    icon?: string;
    values?: any;
    roles?: any;
    error?: any;
    setError?: any
    varCharFieldNames?: string[];
    defaultValues?: any;
    user?: any;
    handleSendOtp?: any;
    handleVerifyEmail?: any;
    style?: React.CSSProperties
}

export default function CustomFields({ row, setValue, values, roles, varCharFieldNames, error, setError, defaultValues, user, handleSendOtp, handleVerifyEmail, style }: Props) {
    const { control } = useFormContext();
    const titles: string[] = [];
    varCharFieldNames?.forEach(fieldName => titles.push(values[fieldName]));

    const [showPassword, setShowPassword] = useState(false);

    const { enqueueSnackbar } = useSnackbar();

    const handleDropSingle = useCallback(
        (acceptedFiles: File[]) => {
            const file = acceptedFiles[0];

            const newFile = Object.assign(file, {
                preview: URL.createObjectURL(file),
            });

            if (file) {
                setValue(row.name, newFile, { shouldValidate: true });
            }
        },
        [setValue, row.name]
    );

    const handleDrop = useCallback(
        (acceptedFiles: File[]) => {
            const files = values[row?.name] || [];

            const newFiles = acceptedFiles.map((file) => {
                const reader: any = new FileReader();
                reader.readAsDataURL(file);

                return new Promise((resolve) => {
                    reader.onloadend = () => {
                        const base64 = (reader?.result || "").split(",")[1];
                        resolve(Object.assign(file, {
                            preview: URL.createObjectURL(file),
                            base64: base64
                        }));
                    };
                });
            });

            Promise.all(newFiles).then((filesWithBase64) => {
                setValue(row?.name, [...files, ...filesWithBase64], { shouldValidate: true });
            });
        },
        [setValue, values, row.name]
    );

    const handleRemoveFile = (inputFile: File | string) => {
        const filtered = values[row?.name] && values[row?.name]?.filter((file: any) => file !== inputFile);
        setValue(row?.name, filtered);
    };

    const handleRemoveAllFiles = () => {
        setValue(row?.name, []);
    };

    return (
        <>
            {RenderSwitch(row, control, handleDrop, handleRemoveFile, handleRemoveAllFiles, handleDropSingle, roles, showPassword, setShowPassword, setValue, values, error, setError, defaultValues, user, enqueueSnackbar, handleSendOtp, handleVerifyEmail, style)}
        </>
    )
}
